require('lessRoot/content-pages/drive-thru.less');
require('lessRoot/content-pages/wish-list-promo.less');
require('lessRoot/content-pages/community.less');
require('lessRoot/content-pages/history.less');
require('lessRoot/content-pages/same-day-delivery.less');
require('lessRoot/content-pages/about-us.less');
require('lessRoot/content-pages/auto-center-coronavirus-update.less');
require('lessRoot/content-pages/virtual-store-tour.less');
require('lessRoot/content-pages/icon-list.less');
require('lessRoot/content-pages/mobile-app.less');


import { BlogCategories, BlogTagGroups } from 'Src/js/services/BlogService';
import { initializeBlogCarousel } from 'Src/js/utilities/blog';

const aboutBlogCarouselRoot = document.querySelector(".about-blog-roll");
if (aboutBlogCarouselRoot) {

	initializeBlogCarousel('#aboutUsBlogCarousel', {
		title: 'Recent Blogs',
		viewAllLink: 'https://www.farmandfleet.com/blog/',
		viewAllLinkAssistiveText: 'Blains Recent Blog Posts',
		//Grabs the 8 most recent blog.
		query: {
			perPage: 8,
		}
	});
}